<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <UserNavigationSidebar></UserNavigationSidebar>
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar></TopNavbar>

      <Message class="mt-4" type="warning-alert" v-if="alertMessage">
        <p slot="alert-message" class="mb-0">{{ alertMessage }}</p>
      </Message>

      <div class="card">
        <section id="profile-content" class="mt-5">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <UserSubscriptions></UserSubscriptions>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/Navigations/TopNavbar';
import UserNavigationSidebar from '@/components/Navigations/UserNavigationSidebar';
import Message from '@/components/AlertMessages/Message';

import UserSubscriptions from '@/components/User/Subscriptions';

export default {
  components: {
    TopNavbar,
    UserNavigationSidebar,
    UserSubscriptions,
    Message,
  },
  data: () => ({
    alertMessage: '',
  }),
};
</script>